import { compressionAccionesRoles } from '../../acciones-roles/departamentos/compresion-acciones-roles';
import { SideBarButton } from '../../nav-list/recursive-sidebar/class/sidebar';
import {
  PreConfigButton2,
  PreConfigButton3,
} from '../../nav-list/recursive-sidebar/configuration/preconfig';

export const CompressionRoutes: SideBarButton = {
  data: {
    name: 'Rubber',
    appendUrl: './compression',
    roles: compressionAccionesRoles.sideNavActions.main,
  },
  options: PreConfigButton2,
  butons: [
    {
      data: {
        name: 'Proceso',
        url: '/scheduling',
        roles: compressionAccionesRoles.sharedActions.scheduling,
      },
      options: PreConfigButton3,
    },
    // {
    //   data: {
    //     name: 'Batches',
    //     url: '/batches',
    //     roles: compressionAccionesRoles.sharedActions.batches,
    //   },
    //   options: PreConfigButton3,
    // },
    {
      data: {
        name: 'Registro Por Maquina',
        url: '/scheduler-v2',
        otherUrls: ['/scheduler-v2/machine/:machineId'],
        roles: compressionAccionesRoles.sharedActions.schedulerV2,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Calidad',
        url: '/quality-control',
        roles: compressionAccionesRoles.sharedActions.qualityControl,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Empaque',
        url: '/packaging',
        roles: compressionAccionesRoles.sharedActions.packaging,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Validacion',
        url: '/validation',
        roles: compressionAccionesRoles.sharedActions.validation,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Etiquetas',
        url: '/packing-box',
        roles: compressionAccionesRoles.sharedActions.packingBox,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Moldes',
        url: '/molds',
        roles: compressionAccionesRoles.sharedActions.molds,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Agregar Datos QC',
        url: '/qc-data',
        roles: compressionAccionesRoles.sharedActions.qcData,
      },
      options: PreConfigButton3,
    },
    // {
    //   data: {
    //     name: 'Reporte',
    //     url: '/performance-report',
    //     roles: compressionAccionesRoles.sharedActions.performanceReport,
    //   },
    //   options: PreConfigButton3,
    // },
    {
      data: {
        name: 'Reporte Power BI',
        overWriteUrl: './reportsPBI/compression',
        // roles: compressionAccionesRoles.sideNavActions.reportsPbiCompression,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Sistema Cobot',
        url: '/cobot',
        roles: compressionAccionesRoles.sharedActions.cobot,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Cobot Monitor',
        url: '/cobot/display',
        roles: compressionAccionesRoles.sharedActions.cobot,
      },
      options: PreConfigButton3,
    },
  ],
};
